module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('base-modal', {
    attrs: {
      "modal-title": 'Pivot Picker'
    },
    on: {
      "close": function($event) {
        return _vm.close()
      },
      "save": function($event) {
        return _vm.save()
      }
    }
  }, [_c('FormulateForm', [_c('table', {
    staticClass: "table table-noborder"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Field")]), _c('th')])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.pivots), function(pivot, ix) {
    return _c('tr', [_c('th', [_vm._v(_vm._s(pivot.field.name))]), _vm._v(" "), _c('td', [_c('FormulateInput', {
      attrs: {
        "type": "button",
        "label": "Remove"
      },
      on: {
        "click": function($event) {
          return _vm.pivots.splice(ix, 1)
        }
      }
    })], 1)])
  }), _vm._v(" "), _c('tr', [_c('td', [_c('FormulateInput', {
    attrs: {
      "type": "select",
      "name": "field",
      "options": _vm.availablePivots
    },
    model: {
      value: (_vm.pivotToAdd),
      callback: function($$v) {
        _vm.pivotToAdd = $$v
      },
      expression: "pivotToAdd"
    }
  })], 1), _vm._v(" "), _c('td', [_c('FormulateInput', {
    staticClass: "add",
    attrs: {
      "type": "button",
      "label": "Add"
    },
    on: {
      "click": _vm.add
    }
  })], 1)])], 2)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fca03d30"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/PivotPickerModal.vue
// module id = 686
// module chunks = 0